import 'core-js/stable';
import 'regenerator-runtime/runtime';
import HashPopupWhitelists from '../constants/HashPopupWhitelists';
import PopupOpenConfigStorage from '../constants/PopupOpenConfigStorage';
// @ts-ignore
import * as errorToolTip from './errorToolTip';
import './modules/registration_popup/registrationV3';
import './modules/registration_popup/registarionV3WithSubscription';
import './modules/registration_popup/registarionWithPollAb';
import './modules/popupFunctions';
import './modules/jsForm';
import 'lightslider';
import 'cloud9carousel';
import { JsFormResponseHandlerObject } from './modules/jsFormTypes';
import { PopupIds } from '../constants/PopupIds';
import { StretchPopup } from '../popups/stretchPopup';
import { PopupManager } from '../popups/popupManager';
import { onReadyCalcBack } from './calcIndexBackAndPopup';
import { startupConfigureCommonUnauth } from '../startup/configure';
import { exposeLoginHandlerFunctions } from '../login/common';
import { initFbSdk } from '../login/fb';
import { LoginFormContent } from '../view/login-form-content';
import { setupPassStrengthWidgetListener } from '../view/password-strength-widget';
import { CurrentEntryPoint } from '../constants/CurrentEntryPoint';
import { GoogleSignIn } from '../login/google/google-sign-in';
import { GoogleOneTap } from '../login/google/google-one-tap';
import { Environment } from '../environment/environment';
import { MobileLpFormHandlers } from './modules/registration_popup/MobileLpFormHandler';
import { initAppleId } from "../login/apple_id";

startupConfigureCommonUnauth();
$(onDocumentReady);

enum LoginErrorCode {
    COMMON_ERROR = 0,
    NOT_REGISTERED = 1,
    WRONG_PASSWORD = 2,
    REQUIRED_2FA = 3,
    INVALID_2FA = 4,
    FORCE_PASS_CHANGE = 5,
    EMAIL_EMPTY = 6,
    PASS_EMPTY = 7,
    TO_BE_DELETED = 5006
}

function openPopupFromLocationHash(): void {
    let popupId: PopupIds;
    const whitelist = HashPopupWhitelists.SITE_INDEX;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    popupId = window.location.hash.slice(1).split('?') as any;
    popupId = popupId[0] as PopupIds;

    if (whitelist.indexOf(popupId) !== -1) {
        window.app.closePopups();
        window.app.popup(PopupOpenConfigStorage.getPopupOpenConfig(popupId));
        PopupManager.openSingle(popupId);
    }
}

function setupListeners(): void {
    $('.popup .js-close-button').on('click', function handlePopupJsCloseClick() {
        window.app.closePopups();
        PopupManager.openSingle(PopupIds.REGISTRATION);
    });
    $('.popup2 .js-close-button').on('click', function handlePopup2JsCloseClick() {
        window.app.closePopups({ hideclass: 'popup2' });
    });
    $('.js-toggle-checked').on('click', function handleJsToggleChecked() {
        $(this).toggleClass('checked');
    });

    $('[data-go-top]').on('click', scrollTop);


    setupPassStrengthWidgetListener();
}

type LoginError = {
    error?: {
        code: number,
        message: string
        data?: {
            id: number,
            token: string,
            deleteAt: string
        }
    }
}
/** email login */
function emailLoginFormHandler(data: JsFormResponseHandlerObject<LoginError>): void {
    const response = data.response;
    const loginForm = LoginFormContent.fromForm(data.form, data.caller.data('tooltipdirection'));

    loginForm.hideErrors();

    if (response.error) {
        if ([LoginErrorCode.EMAIL_EMPTY].includes(response.error.code)) {
            loginForm.showEmailError(response.error.message);
            return;
        }

        if ([
            LoginErrorCode.PASS_EMPTY,
            LoginErrorCode.WRONG_PASSWORD
        ].includes(response.error.code)) {
            loginForm.showPasswordError(response.error.message);
            return;
        }

        if ([
            LoginErrorCode.FORCE_PASS_CHANGE
        ].includes(response.error.code)) {
            PopupManager.openSingle(PopupIds.RESTORE_PASS);

            setTimeout(() => {
                const restoreButton = $('.restore-form__restore-button:visible');
                errorToolTip(restoreButton, this.showTooltipOnLeft, response.error.message);
                const email = $('input[name=email]', data.form).val() as string;
                fillRestorePassEmail(email);
            }, 100);
            // window.app.popup(PopupOpenConfigStorage.getPopupOpenConfig(PopupIds.RESTORE_PASS));
            return;
        }

        if ([
            LoginErrorCode.REQUIRED_2FA,
            LoginErrorCode.INVALID_2FA
        ].includes(response.error.code)) {
            loginForm.show2FaForm();
            loginForm.show2FaError(response.error.message);
            return;
        }

        if ([LoginErrorCode.TO_BE_DELETED].includes(response.error.code)) {
            window.app.handleAccountToBeDeleted(
                response.error.data.id,
                response.error.data.token,
                response.error.data.deleteAt
            );
            return;
        }

        loginForm.showSubmitButtonError(response.error.message);
    } else {
        location.reload();
    }
}

function fillRestorePassEmail(email: string) {
    $('#restore_pass input[type="email"]').val(email);
}

function onDocumentReady() {
    PopupManager.init();
    StretchPopup.stretch();
    $(window).on('resize', () => {
        StretchPopup.stretch();
    });

    window.app.login_form_handler = emailLoginFormHandler;


    if (window.location.hash) {
        openPopupFromLocationHash();
    }
    setupListeners();
    exposeLoginHandlerFunctions();
    initLoginMethods();
    initSeoIndexCarousels();

    onReadyCalcBack();
    $('video').on('load loadedmetadata', () => {
        onReadyCalcBack();
    });

    if (Environment.isLanding()) {
        initLpHandlers();
    }
}

function initLoginMethods() {
    initFbSdk();
    if (!window.app.isSite1) {
        initAppleId();
    }
    new GoogleSignIn(window.app.config.google).init();
    if (isItAllowedForGoogleOneTap()) {
        const googleIneTap = new GoogleOneTap(window.app.config.google);
        googleIneTap.init();
    }
}
function isItAllowedForGoogleOneTap(): boolean {
    if ((!window.app.config.landings.enableGoogleOneTap && Environment.isLanding())) {
        return false;
    }

    if (![CurrentEntryPoint.SITE, CurrentEntryPoint.SITE2].includes(window.app.config.current_entry_point)) {
        return false;
    }

    return true;
}

function scrollTop() {
    $(document).scrollTop(0);
}


function initSeoIndexCarousels() {
    // @ts-ignore
    $('#carousel').Cloud9Carousel({
        buttonLeft: $('.navigate-right'),
        buttonRight: $('.navigate-left'),
        frontItemClass: 'active',
        itemClass: 'slide',
        yOrigin: 0,
        yRadius: -24
    });

    // @ts-ignore
    $('.seo-index-layout__feedback').lightSlider({
        adaptiveHeight: window.app.isMobile,
        item: 1,
        nextHtml: '<div class=\'seo-index-layout__navigate-right\'></div>',
        prevHtml: '<div class=\'seo-index-layout__navigate-left\'></div>'
    });
}

function initLpHandlers(): void {
    const mobileLpHandlers = new MobileLpFormHandlers(window.app.config);
    mobileLpHandlers.registerHandlers();
}


